// Catálogo de presets de som, curado e fixo (sem tabela no banco).
// novo_pedido e chamada_senha compartilham o mesmo catálogo (PRESETS_PEDIDO)
// porque a ideia sonora dos dois é "avisar que tem pedido/cliente esperando" —
// os campos continuam salvos separadamente em tb_empresa.config_sons, só a
// lista de opções oferecida é compartilhada.
// Ver docs/ativo/plano-implementacao-sons-customizaveis.txt.

export const PRESETS_PEDIDO = [
  { chave: 'padrao', label: 'Padrão (atual)', arquivo: '/sounds/novo-pedido.mp3' },
  { chave: 'sino-1', label: 'Sino 1', arquivo: '/sounds/presets/pedido-sino-1.mp3' },
  { chave: 'sino-2', label: 'Sino 2', arquivo: '/sounds/presets/pedido-sino-2.mp3' },
  { chave: 'sino-3', label: 'Sino 3', arquivo: '/sounds/presets/pedido-sino-3.mp3' },
];

export const PRESETS_ALERTA_WHATSAPP = [
  { chave: 'padrao', label: 'Padrão (atual)', arquivo: '/sounds/alert.mp3' },
  { chave: 'atendimento-1', label: 'Atendimento 1', arquivo: '/sounds/presets/atendimento-1.mp3' },
  { chave: 'atendimento-2', label: 'Atendimento 2', arquivo: '/sounds/presets/atendimento-2.mp3' },
  { chave: 'atendimento-3', label: 'Atendimento 3', arquivo: '/sounds/presets/atendimento-3.mp3' },
];

export const CATALOGOS_POR_EVENTO = {
  novo_pedido: PRESETS_PEDIDO,
  chamada_senha: PRESETS_PEDIDO,
  alerta_whatsapp: PRESETS_ALERTA_WHATSAPP,
};

// Arquivo hardcoded atual, usado como fallback quando a empresa não
// configurou nada pra aquele evento (config_sons ausente ou sem a chave).
export const SOM_PADRAO_POR_EVENTO = {
  novo_pedido: '/sounds/novo-pedido.mp3',
  chamada_senha: '/sounds/novo-pedido.mp3',
  alerta_whatsapp: '/sounds/alert.mp3',
};

// Presets/fallback são servidos pelo próprio frontend (frontend/public/sounds),
// então usam PUBLIC_URL. Uploads são servidos pelo backend (/api/uploads/,
// caminho relativo salvo em config_sons), então usam REACT_APP_API_URL —
// mesmo padrão já usado pra imagem de produto/seção/logo.
export function resolverUrlSom(evento, configEvento) {
  if (!configEvento) {
    return process.env.PUBLIC_URL + SOM_PADRAO_POR_EVENTO[evento];
  }

  if (configEvento.tipo === 'upload') {
    return `${process.env.REACT_APP_API_URL}/${configEvento.valor}`;
  }

  if (configEvento.tipo === 'preset') {
    const catalogo = CATALOGOS_POR_EVENTO[evento] || [];
    const preset = catalogo.find((item) => item.chave === configEvento.valor);
    return process.env.PUBLIC_URL + (preset ? preset.arquivo : SOM_PADRAO_POR_EVENTO[evento]);
  }

  return process.env.PUBLIC_URL + SOM_PADRAO_POR_EVENTO[evento];
}
